import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// Bulk Labour Advance (MOID 702) - backend api/LabourAdvance

export const uploadAdvanceStaging = async (payload) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/LabourAdvance/UploadStaging`, payload, {
            headers: { 'Content-Type': 'application/json' },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to upload advance sheet';
    }
};

export const getAdvanceStagingPreview = async ({ ccCode, month, year }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetStagingPreview`, {
            params: { ccCode, month, year },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch advance preview';
    }
};

export const generateAdvance = async (payload) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/LabourAdvance/Generate`, payload, {
            headers: { 'Content-Type': 'application/json' },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to generate advance';
    }
};

export const getAdvanceDetail = async (advanceId) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetDetail`, {
            params: { advanceId },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch advance detail';
    }
};

export const getAdvanceInbox = async (roleId) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetInbox`, {
            params: { roleId },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch advance inbox';
    }
};

export const approveAdvance = async (payload) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/LabourAdvance/Approve`, payload, {
            headers: { 'Content-Type': 'application/json' },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to submit advance approval';
    }
};

// ── Advance CMS (Labour CMS tables, PaymentFor 'Advance', 658 workflow) ──

export const getAdvanceCMSBatches = async ({ month, year }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetCMSBatches`, { params: { month, year } });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch approved advances';
    }
};

export const getAdvanceCMSContractors = async (advanceId) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetCMSContractors`, { params: { advanceId } });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch contractors';
    }
};

export const getAdvanceCMSWorkerGrid = async ({ advanceId, labourType, contractorCode }) => {
    try {
        const params = { advanceId, labourType };
        if (contractorCode) params.contractorCode = contractorCode;
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetCMSWorkerGrid`, { params });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch advance workers';
    }
};

export const saveAdvanceCMS = async (payload) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/LabourAdvance/SaveCMS`, payload, {
            headers: { 'Content-Type': 'application/json' },
        });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to save advance CMS payment';
    }
};

// ── Labour Advance Report (MOID 704) ──

export const getAdvanceReportCCs = async ({ roleId, userId }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetReportCCs`, { params: { roleId, userId } });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch cost centres';
    }
};

export const getAdvanceReport = async (params) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/LabourAdvance/GetReport`, { params });
        return res.data;
    } catch (err) {
        if (err.response?.data) throw err.response.data;
        throw err.message || 'Failed to fetch labour advance report';
    }
};
